// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"HIDList_EditButton__3_Jhv"};